import {atom} from "recoil";
import {BookmarkType} from "../types/RecruitmentTypes";

export const BookmarksAtom = atom<BookmarkType[]>({
    key: 'ivy.bookmarks.list',
    default: []
})